import { MapPin, Clock, Phone, Mail } from 'lucide-react';

const infoCards = [
  {
    icon: Clock,
    title: 'Öppettider',
    lines: ['Mån–Fre: 08:00–15:00', 'Lunch: 10:30–13:30'],
  },
  {
    icon: MapPin,
    title: 'Hitta hit',
    lines: ['Södra Järnvägsgatan 7', '826 50 Söderhamn'],
    link: 'https://maps.google.com/?q=Södra+Järnvägsgatan+7+Söderhamn',
  },
  {
    icon: Phone,
    title: 'Ring oss',
    lines: ['073-782 57 61'],
    link: 'tel:+46737825761',
  },
  {
    icon: Mail,
    title: 'Maila oss',
    lines: ['restaurangcfl@gmail.com'],
    link: 'mailto:restaurangcfl@gmail.com',
  },
];

export const QuickInfoSection = () => {
  return (
    <section className="section-padding">
      <div className="container-wide mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-display text-3xl md:text-4xl font-semibold text-foreground mb-4">
            Snabb information
          </h2>
          <p className="text-muted-foreground max-w-xl mx-auto">
            Allt du behöver veta för att besöka oss
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {infoCards.map((card, index) => {
            const Icon = card.icon;
            const content = (
              <div
                key={card.title}
                className="card-warm p-6 text-center group hover:border-primary/30 transition-all duration-300 animate-fade-in-up"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 text-primary mb-4 group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-300" aria-hidden="true">
                  <Icon size={24} />
                </div>
                <h3 className="font-display text-lg font-semibold text-foreground mb-2">
                  {card.title}
                </h3>
                {card.lines.map((line, i) => (
                  <p key={i} className="text-muted-foreground text-sm">
                    {line}
                  </p>
                ))}
              </div>
            );

            if (card.link) {
              return (
                <a
                  key={card.title}
                  href={card.link}
                  target={card.link.startsWith('http') ? '_blank' : undefined}
                  rel={card.link.startsWith('http') ? 'noopener noreferrer' : undefined}
                  className="block"
                >
                  {content}
                </a>
              );
            }

            return content;
          })}
        </div>

        {/* Map embed */}
        <div className="mt-12 rounded-xl overflow-hidden shadow-warm border border-border">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1909.7922043772817!2d17.0698479948846!3d61.30290345310564!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4666cb380c2f9113%3A0xcf2de534ed28578d!2sRestaurang%20CFL!5e0!3m2!1ssv!2sse!4v1766829834643!5m2!1ssv!2sse"
            width="100%"
            height="350"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Restaurang CFL på kartan"
          />
        </div>
      </div>
    </section>
  );
};
